import { commonConstants } from '../_constants';
import { initialState } from '../_helpers';

export function airlineLocations(state = initialState.airlineLocations, action) {
    switch (action.type) {
        case commonConstants.GET_AIRLINE_LOCATIONS:
            return action.airlineLocations;
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/airlineLocations.reducer.js